import { useAppSettingsDictionary } from '@/shared/api';
import { useMemo } from 'react';
import type {
  AccessTypeSelectOption,
  AuthenticationTypeSelectOption,
} from './types';

export const useEditApiTokenFormData = () => {
  const { appSettingsData, isAppSettingsLoading, appSettingsError } =
    useAppSettingsDictionary();

  const accessTypes = useMemo<AccessTypeSelectOption[]>(() => {
    if (!appSettingsData) return [];
    return appSettingsData.value.tradingWebapiTokenAccessList.flatMap(access =>
      Object.entries(access).map(([key, value]) => ({
        value: key,
        label: value,
      }))
    );
  }, [appSettingsData]);

  const authenticationTypes = useMemo<AuthenticationTypeSelectOption[]>(() => {
    if (!appSettingsData) return [];
    return appSettingsData.value.tradingWebapiTokenAuthenticationTypes.map(
      type => ({
        value: type,
        label: type,
      })
    );
  }, [appSettingsData]);

  return {
    accessTypes,
    authenticationTypes,
    isLoading: isAppSettingsLoading,
    error: appSettingsError,
  };
};
